/* eslint-disable import/no-anonymous-default-export */
import useFutureTickets from "../../../MyAccount/Reservations/hooks/useReservation";
import { useMemo, useState } from "react";
import { startOfDay } from "date-fns";
import { isEqual, isAfter, isBefore } from "date-fns";

const ITEMS_PER_PAGE = 8;

export default () => {
  const [showPastReservation, setShowPastReservation] = useState(false);
  const [displayedUpcomingCount, setDisplayedUpcomingCount] = useState(ITEMS_PER_PAGE);
  const [displayedPastCount, setDisplayedPastCount] = useState(ITEMS_PER_PAGE);
  const { tickets, loading, refreshTickets } = useFutureTickets();

  // Sort tickets by their exercises' start times
  const sortedTickets = useMemo(() => {
    if (!tickets || tickets.length === 0) return [];

    // Create a copy to avoid mutating original data
    return [...tickets].map((ticket) => {
      // Sort exercises within each ticket from earliest to latest
      const sortedExercises = [...ticket.exercises].sort((a, b) => {
        // Handle cases where startTime might be undefined
        if (!a.startTime) return 1; // Undefined dates go last
        if (!b.startTime) return -1;
        return a.startTime - b.startTime;
      });

      return { ...ticket, exercises: sortedExercises };
    });
  }, [tickets]);

  const isTodayOrLater = (dateNumber: number): boolean => {
    const today = startOfDay(new Date());
    const inputDate = startOfDay(new Date(dateNumber));

    return isEqual(inputDate, today) || isAfter(inputDate, today);
  };

  const isEarlierThanToday = (dateNumber: number): boolean => {
    const today = startOfDay(new Date());
    const inputDate = startOfDay(new Date(dateNumber));

    return isBefore(inputDate, today);
  };

  const hasValidTicket = sortedTickets.some((ticket) =>
    ticket.exercises.some((exercise) => isEarlierThanToday(exercise.startTime) && ticket.ticket === false)
  );

  // Create flat array of upcoming reservations for sorting
  const upcomingReservations = sortedTickets.flatMap((ticket) =>
    ticket.exercises
      .filter((exercise) => exercise.startTime && isTodayOrLater(exercise.startTime))
      .map((exercise) => ({ ticket, exercise }))
  );

  // Sort upcoming reservations by start time (earliest first)
  upcomingReservations.sort((a, b) => {
    return a.exercise.startTime - b.exercise.startTime;
  });

  // Create flat array of past reservations
  const pastReservations = sortedTickets.flatMap((ticket) =>
    ticket.exercises
      .filter((exercise) => exercise.startTime && isEarlierThanToday(exercise.startTime))
      .map((exercise) => ({ ticket, exercise }))
  );

  // Sort past reservations by start time (latest first)
  pastReservations.sort((a, b) => {
    return b.exercise.startTime - a.exercise.startTime;
  });

  return {
    upcomingReservations,
    pastReservations,
    hasValidTicket,
    loading,
    refreshTickets,
    sortedTickets,
    isEarlierThanToday,
    showPastReservation,
    setShowPastReservation,
    displayedUpcomingCount,
    setDisplayedUpcomingCount,
    displayedPastCount,
    setDisplayedPastCount,
    ITEMS_PER_PAGE,
  };
};